export default "__VITE_ASSET__ByV5y4WS__"